<template>
    <div class="bbpay-header">
        <Stepper 
            class="spacing-b-5"
            :active-step="stepIndex"
            :steps="stepLabels"
            :checked-steps="stepperConfig.checkedSteps"
            data-html2canvas-ignore="true"
        />
        <h2 class="bbpay-header__title spacing-b-2">
            {{ $ml.get('payment') }} {{ $ml.get(stepLabels[stepIndex]).toLowerCase() }}
        </h2>
        <span class="bbpay-header__text spacing-b-5">
            {{ $ml.get('bBYouPaid') }} <strong>{{ merchantName }}</strong>
        </span>
        <HighlightBox>
            <span v-html="highlightHtml" />
        </HighlightBox>
    </div>
</template>

<script>
import Stepper from '@/components/OrderStatus/components/Stepper';
import HighlightBox from '@/components/HighlightBox';

export default {
    props: {
        stepIndex: {
            type: Number,
            default: 0
        },
        stepLabels: {
            type: Array,
            default: () => []
        },
		stepperConfig: {
            type: Object,
            required: true
        },
        merchantName: {
            type: String,
            default: ''
        },
        highlightEmail: {
            type: String,
            default: ''
        },
		status: {
			type: String,
			default: ''
		},
    },
    components: {
        Stepper,
        HighlightBox
    },
	computed: {
		highlightHtml() {
			const key = this.status === 'paid' ? 'bBHighlightTextPaid' : 'bBHighlightTextPending';
			const rawText = this.$ml.get(key);
			return rawText.replace('{0}', `<strong style="font-weight: 600;">${this.highlightEmail}</strong>`);
		}
    }
};
</script>

<style lang="scss" scoped>
    .bbpay-header {
        
        &__title {
            display: block;
            font-size: 24px;
            font-weight: 700;
            color: #2F363E;
        }

        &__text {
            display: block;
            font-size: 16px;
            color: #5C6A7B;
        }
    }
</style>
